const testimonials = [
  {
    name: "阿澄",
    tag: "游戏开黑 · 3年用户",
    text: "开黑房语音延迟真的低，指挥战况特别顺畅，几个老伙计天天在这打配合，体验一直很稳。",
  },
  {
    name: "小鹿",
    tag: "兴趣社区 · 会员",
    text: "开通会员后进频道的音质和优先通道都很实用，客服响应也快，问充值到账的事几分钟就解决了。",
  },
  {
    name: "老K",
    tag: "直播观众 · 5年用户",
    text: "直播间画质清晰、弹幕互动流畅，礼物系统也很方便，是我待得最久的一个平台。",
  },
];

const principles = [
  { icon: "ri-heart-line", title: "热爱优先", desc: "尊重每一种热爱，让兴趣社区自由生长。" },
  { icon: "ri-shield-check-line", title: "安全可信", desc: "官方渠道与多层加密，守护账号与资金安全。" },
  { icon: "ri-lightbulb-flash-line", title: "持续创新", desc: "不断打磨语音技术，优化每一次连接体验。" },
];

export default function Reputation() {
  return (
    <section className="relative bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-primary-400">
              <i className="ri-star-smile-line" aria-hidden="true"></i>
              口碑与品牌
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">被千万用户信赖的声音</h2>
            <p className="mt-4 text-foreground-300">
              歪歪始终相信，好的产品经得起口碑的检验。我们把每一份热爱放在心上，用稳定的技术、贴心的服务与真诚的社区氛围，陪伴每一位用户。
            </p>

            <div className="mt-7 space-y-4">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-4 rounded-xl border border-background-200/70 bg-background-100 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base text-foreground-50">{p.title}</h3>
                    <p className="mt-0.5 text-sm text-foreground-400">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {testimonials.map((t) => (
              <article
                key={t.name}
                className="flex flex-col rounded-xl border border-background-200/70 bg-background-100 p-5"
              >
                <div className="flex gap-0.5 text-primary-400" aria-label="五星好评">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-200">“{t.text}”</p>
                <div className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500/20 text-secondary-300">
                    <i className="ri-user-3-fill" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-50">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.tag}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}